import React, { useState } from 'react';
import { Helix2000Character } from '../../../../shared/CharacterTypes';
import { GameConstants } from '../../../../shared/GameConstants';
import { gameLogger } from '../../../../utils/GameLogger';
import { GlobalPhysics } from './Physics/GlobalPhysics';
import { CharacterFeel } from './Physics/CharacterFeel';
import { PhysicsProfiles } from './Physics/PhysicsProfiles';
import { buttonStyle } from './Physics/styles';

interface PhysicsToolsTabProps {
    player: Helix2000Character;
    onAction: (action: string, data?: any) => void;
}

export const PhysicsToolsTab: React.FC<PhysicsToolsTabProps> = ({ player, onAction }) => {
  const [, setRefreshTrigger] = useState(0);

  const refresh = () => {
    setRefreshTrigger(prev => prev + 1);
    onAction('refresh_physics');
  };

  const handlePhysicsChange = (key: string, value: number) => {
    (GameConstants.Physics as any)[key] = value;
    refresh();
  };

  const handlePlayerPhysicsChange = (key: string, value: number) => {
    if (player.movementStats) {
      (player.movementStats as any)[key] = value;
      refresh();
    }
  };

  return (
    <>
      <GlobalPhysics onPhysicsChange={handlePhysicsChange} />
      <CharacterFeel player={player} onPlayerPhysicsChange={handlePlayerPhysicsChange} />
      <PhysicsProfiles player={player} onRefresh={refresh} />

      <button
        style={{ ...buttonStyle, background: '#e67e22', borderColor: '#d35400', marginTop: '15px' }}
        onClick={() => {
          gameLogger.info('physics', 'Current Physics Export:', {
            GameConstants: GameConstants.Physics,
            CharacterStats: player.movementStats
          });
          alert('Physics settings logged to console!');
        }}
      >
        📋 Export Settings to Console
      </button>
    </>
  );
};
